import React from "react";
export const IconPlane = () => <svg class="icon-plane" width="21px" height="18px" viewBox="0 0 21 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="icon-send-1" transform="translate(-2.000000, -4.000000)" fill="#979797">
            <g id="icon-send">
                <polygon id="Page-1" points="2 4 2 11 17 13 2 15.001 2 22 23 13"></polygon>
            </g>
        </g>
    </g>
</svg>